import { Check, ChevronDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"

// Small "Sort: <current>" dropdown shared by Find Freelancers + Favorites.
// `options` are [{ key, label }]; `value` is the selected key. Built on the DS
// DropdownMenu primitive (radio group): Radix owns open state, outside-click +
// Escape dismissal, and ARIA. The trigger's open/hover chrome is driven off
// Radix's data-[state=open] instead of a local `open` flag (Hallmark §5d).
export default function SortDropdown({ value, options, onPick }) {
  const current = options.find((o) => o.key === value) ?? options[0]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="group flex items-center gap-[8px] rounded-[11px] border border-border bg-card px-[14px] py-[11px] text-[13px] font-semibold whitespace-nowrap transition-colors hover:border-line-2 data-[state=open]:border-foreground"
        >
          <span className="font-semibold text-ink-3">Sort:</span>
          {current?.label}
          <ChevronDown
            className="size-[15px] text-ink-3 transition-transform group-data-[state=open]:rotate-180"
            strokeWidth={2}
          />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        sideOffset={7}
        className="min-w-[214px] rounded-[13px] border-border bg-card p-[7px] shadow-[0_20px_46px_-16px_rgba(0,0,0,0.34)]"
      >
        <DropdownMenuLabel className="px-[11px] pt-[7px] pb-[6px] text-[10px] font-bold tracking-[0.09em] text-ink-3 uppercase">
          Sort by
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup value={value} onValueChange={onPick}>
          {options.map((o) => (
            <DropdownMenuRadioItem
              key={o.key}
              value={o.key}
              className={cn(
                "gap-[11px] rounded-[9px] px-[11px] py-[10px] text-left text-[13.5px] [&>span:first-child]:hidden",
                o.key === value ? "bg-accent font-bold" : "font-medium"
              )}
            >
              <span className="flex-1">{o.label}</span>
              {o.key === value && <Check className="size-4 text-foreground" strokeWidth={2.6} />}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
